export enum SecureNoteType {
    Generic = 0,
}
